<div
  class="h-full flex flex-col"
  [class]="floatingPageClasses()"
  [class.justify-between]="!floating()">
  <div
    class="flex flex-wrap items-center justify-between gap-lg"
    [class]="floating() ? 'mb-lg' : 'mb-2xl'">
    <h1 class="text-2xl font-semibold text-neutral-900">
      {{ 'workflow_configurations_screen_title' | transloco }}
    </h1>
    @if (floating()) {
      <ng-container [ngTemplateOutlet]="tableActionSection" />
    }
  </div>

  <section
    [class]="floating() ? 'floating-card p-2xl flex flex-col' : 'contents'"
    data-testid="workflow-configuration-section">
    <ng-template #workflowsSearch>
      <div class="flex items-center gap-md shrink-0">
        <lib-search-field
          [searchInputWidth]="searchInputWidth"
          [placeholder]="'search_by_name_placeholder'"
          (searchKeywordEmitter)="onSearchTermChange($event)" />
      </div>
    </ng-template>

    <div
      class="flex items-center justify-between mb-lg gap-lg"
      [class]="floating() ? '' : 'py-lg border-b border-neutral-200'">
      <div class="flex items-center gap-lg min-w-0">
        @if (!floating()) {
          <h5 class="text-lg font-semibold text-neutral-900">
            {{ 'workflow_configurations_screen_sub_title' | transloco }}
          </h5>
        }

        <lib-badge
          [label]="workflowsCount()"
          [badgeClass]="'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'" />
      </div>

      <!-- Tables_new_design shows the search in the table toolbar instead -->
      @if (!searchInToolbar()) {
        <ng-container [ngTemplateOutlet]="workflowsSearch" />
      }
    </div>

    <ng-template #tableActionSection>
      @if (workflowBuilderEnabled) {
        <lib-button
          id="workflow_configuration_new_button"
          [label]="'custom_workflow_new_button' | transloco"
          [btnClass]="'px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none'"
          (click)="openCreate()" />
      }
    </ng-template>

    <lib-table
      [tableClass]="'h-auto min-h-[calc(100vh-25rem)] w-full whitespace-nowrap'"
      [id]="'workflow_configurations_table'"
      [dataSource]="tableRows()"
      [loading]="isLoading()"
      [columns]="columns()"
      [noDataTitle]="'table_no_data_title' | transloco"
      [noDataDescription]="'section_no_data_description' | transloco"
      [tableActionSectionRef]="floating() ? null : tableActionSection"
      [bodyTemplateRef]="
        workflowBuilderEnabled
          ? [
              number,
              workflow_name,
              workflow_kind,
              workflow_type,
              workflow_steps,
              workflow_sla,
              workflow_status,
              action,
            ]
          : [
              number,
              workflow_name,
              workflow_type,
              workflow_steps,
              workflow_sla,
              action,
            ]
      "
      [tableFilterTabs]="tableFilterTabs()"
      [searchTemplateRef]="searchInToolbar() ? workflowsSearch : null"
      [titleBottomBorder]="false"
      [lastColumnAlignment]="'justify-end'"
      (handleViewIconClick)="open($event)">
      <ng-template #number let-row let-i="i">
        {{ (currentPage() - 1) * currentSize() + (i + 1) }}
      </ng-template>

      <ng-template #workflow_name let-row>
        <div class="flex items-center gap-md">
          <lib-avatar
            [fullName]="row.name"
            [img]="row.icon?.url"
            borderRadius="rounded-full" />

          <div class="w-[13.4375rem] text-wrap">
            {{ row.name | truncate: 66 }}
          </div>
        </div>
      </ng-template>

      <ng-template #workflow_kind let-row>
        <lib-badge
          [label]="
            (row.kind === 'dynamic'
              ? 'workflow_configurations_kind_dynamic'
              : 'workflow_configurations_kind_built_in'
            ) | transloco
          "
          [badgeClass]="
            row.kind === 'dynamic'
              ? 'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'
              : 'px-sm border-none text-sm font-medium bg-neutral-100 text-neutral-700'
          " />
      </ng-template>

      <ng-template #workflow_type let-row>
        <div class="w-60 text-wrap">
          {{ row.category.name | truncate: 72 }}
        </div>
      </ng-template>

      <ng-template #workflow_steps let-row>
        {{ row.step_templates_count }}
      </ng-template>

      <ng-template #workflow_sla let-row>
        {{ row.sla }}
      </ng-template>

      <ng-template #workflow_status let-row>
        <lib-badge
          [label]="'custom_workflow_status_' + row.status | transloco"
          [badgeClass]="
            'px-sm border-none text-sm font-medium ' + (row.status | status)
          " />
      </ng-template>

      <ng-template #action let-row>
        <lib-action-list
          [parentName]="'workflow_configurations_table'"
          [menuItems]="row.actions"
          (itemClick)="onAction($event, row)" />
      </ng-template>
    </lib-table>

    @if (configurationList().length) {
      <lib-paginator
        class="mt-2xl"
        [sizeOptionsLabel]="
          'pagination_number_of_rows_per_page_label' | transloco
        "
        [nextBtnLabel]="'pagination_next_button_label' | transloco"
        [previousBtnLabel]="'pagination_previous_button_label' | transloco"
        [currentPage]="currentPage()"
        [totalPages]="totalPages()"
        [totalItems]="+workflowsCount()"
        [showChangeSize]="true"
        [sizeOptions]="pageSizeOptions"
        (goTo)="handlePagination($event)"
        (next)="handlePagination($event)"
        (previous)="handlePagination($event)"
        (handleChangeSize)="changeSize($event)"
        [currentSize]="currentSize()" />
    }
  </section>
</div>

<ng-template #deleteConfirm>
  <div class="text-center font-medium text-lg text-neutral-900 mb-sm">
    {{ 'custom_workflow_delete_confirm_title' | transloco }}
  </div>
  <div class="text-center text-sm text-neutral-500">
    {{ 'custom_workflow_delete_confirm_description' | transloco }}
  </div>
  <div class="flex flex-col gap-md mt-4xl">
    <button
      id="workflow_configuration_delete_confirm"
      class="px-2xl py-sm rounded-md text-white bg-destructive-600 text-lg font-medium border-none cursor-pointer"
      (click)="confirmDelete()">
      {{ 'custom_workflow_delete_confirm_button' | transloco }}
    </button>
    <button
      id="workflow_configuration_delete_cancel"
      class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300 cursor-pointer"
      (click)="cancelDelete()">
      {{ 'custom_workflow_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #createModal>
  <form [formGroup]="createForm" class="flex flex-col gap-xl">
    <h3 class="text-lg font-semibold text-neutral-900">
      {{ 'custom_workflow_create_title' | transloco }}
    </h3>
    <div>
      <div formGroupName="name">
        <lib-dual-lang-input
          [requiredGroup]="true"
          [inputFormControlName]="'name'"
          [id]="'custom_workflow_name'"
          type="text"
          name="name"
          [requiredEn]="false"
          [requiredAr]="false"
          [label]="'custom_workflow_name_label' | transloco"
          [placeholderEn]="'custom_workflow_name_en_label' | transloco"
          [placeholderAr]="'custom_workflow_name_ar_label' | transloco" />
      </div>
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="name" />
    </div>
    <div>
      <lib-select
        [inputFormControlName]="'category_id'"
        id="custom_workflow_category"
        name="category_id"
        [required]="true"
        [options]="categories()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [label]="'custom_workflow_category_label' | transloco"
        [placeholder]="'custom_workflow_category_placeholder' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="category_id" />
    </div>
    <lib-upload-files
      [uploadedFiles]="noFiles"
      [id]="'icon'"
      [name]="'icon'"
      [uploadUrl]="uploadFileUrls.upload"
      [removeUrl]="uploadFileUrls.remove"
      [label]="'custom_workflow_icon_label' | transloco"
      [inputFormControlName]="'icon'"
      [accept]="'jpg,jpeg,png,webp'"
      [multiple]="false"
      [fileSizeLimit]="2048 * 1000"
      [viewOnly]="false"
      [required]="false"
      [uploadedFileLimit]="1"
      [uploadFileLabels]="iconUploadLabels()" />
    <div class="flex justify-end gap-md">
      <lib-button
        id="workflow_configuration_create_cancel"
        [label]="'custom_workflow_cancel_button' | transloco"
        [btnClass]="'px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300'"
        (click)="closeCreate()" />
      <lib-button
        id="workflow_configuration_create_submit"
        [disabled]="isSaving()"
        [label]="'custom_workflow_create_button' | transloco"
        [btnClass]="'px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none'"
        (click)="submitCreate()" />
    </div>
  </form>
</ng-template>
